/**
 * Resolve an image URL from the backend.
 * - Cloudinary / absolute URLs → returned as-is
 * - Relative /uploads/... paths → prepend the API base origin
 * - null / undefined → return null
 */
const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api')
  .replace(/\/api\/?$/, '');

export function resolveImage(src) {
  if (!src) return null;
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  // relative path like /uploads/file.jpg
  return `${API_ORIGIN}${src.startsWith('/') ? '' : '/'}${src}`;
}
